module.exports = __webpack_public_path__ + "static/1 (12)-ea92f6324574d17370ca664388c02bd2.png";